module.exports = __webpack_public_path__ + "img/linkedin-contact.38fb4849.svg";